import React from "react";
import { useTranslation } from "react-i18next";
import { LabelColumn, Row, ValueColumn } from "src/components/shared/Sidebar/SidebarTable";
import { localizeCurrencyWithDecimals } from "src/utils";

interface Props {
    taxes: number;
    monthly?: boolean;
}

const Taxes = ({ taxes, monthly = false }: Props) => {
    const { t } = useTranslation();

    if (!taxes) {
        return null;
    }

    return (
        <Row>
            <LabelColumn>
                {monthly ? t("ContinueDeal.VehicleInfo.monthlySalesLabel") : t("ContinueDeal.VehicleInfo.taxesLabel")}
            </LabelColumn>
            <ValueColumn>
                {monthly
                    ? t("ContinueDeal.VehicleInfo.monthlySalesSummary", {
                          summary: taxes,
                      })
                    : localizeCurrencyWithDecimals(taxes)}
            </ValueColumn>
        </Row>
    );
};

export default Taxes;
